import { render } from "./SelectInputWithSubtitles.vue?vue&type=template&id=3b699a00&ts=true"
import script from "./SelectInputWithSubtitles.vue?vue&type=script&lang=ts"
export * from "./SelectInputWithSubtitles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__